import { css } from '@emotion/react';

import { media } from '../shared/styles';

// Background color for the gallery
export const galleryBackgroundStyles = css`
  background-color: var(--color-base-black, #000000);
`;

// Image styling
export const imageStyles = css`
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  object-fit: contain;
  border-radius: var(--radius-md, 8px);

  ${media.md} {
    max-height: calc(100vh - var(--spacing-32));
  }
`;

// Counter badge styling
export const counterStyles = css`
  transform: translateX(-50%);
  color: var(--color-base-white, #ffffff);
  background-color: rgba(0, 0, 0, 0.5);
  padding: var(--spacing-2) var(--spacing-4);
  border-radius: var(--radius-full, 9999px);
`;

// Caption styling
export const captionStyles = css`
  transform: translateX(-50%);
  color: var(--color-base-white, #ffffff);
  text-align: center;
  padding: var(--spacing-2) var(--spacing-4);
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: var(--radius-md, 8px);
  max-width: 80%;
`;

// Shared navigation button styles
const navigationButtonStyles = css`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: var(--spacing-12);
  height: var(--spacing-12);
  background-color: rgba(255, 255, 255, 0.9);
  border: none;
  border-radius: var(--radius-round, 50%);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10;
  transition: background-color 0.15s ease, transform 0.15s ease;
  box-shadow: var(--shadow-md, 0 4px 6px rgba(0, 0, 0, 0.1));

  &:hover {
    background-color: var(--color-base-white, #ffffff);
    transform: translateY(-50%) scale(1.05);
  }

  &:active {
    transform: translateY(-50%) scale(0.95);
  }

  &:focus {
    outline: 2px solid var(--border-focus, #3e704b);
    outline-offset: 2px;
  }
`;

export const prevButtonStyles = css`
  ${navigationButtonStyles}
  left: var(--spacing-4);
`;

export const nextButtonStyles = css`
  ${navigationButtonStyles}
  right: var(--spacing-4);
`;

// Dots container positioning (transform for centering)
export const dotsContainerPositionStyles = css`
  transform: translateX(-50%);
`;

// Individual dot styling
export const dotStyles = css`
  width: var(--spacing-2);
  height: var(--spacing-2);
  border-radius: var(--radius-round, 50%);
  background-color: rgba(255, 255, 255, 0.5);
  border: none;
  padding: 0;
  cursor: pointer;
  transition: background-color 0.15s ease, transform 0.15s ease;

  &:hover {
    background-color: rgba(255, 255, 255, 0.8);
    transform: scale(1.2);
  }
`;

export const dotActiveStyles = css`
  background-color: var(--color-base-white, #ffffff);
  transform: scale(1.2);
`;

// Modal override styles
export const closeButtonOverrideStyles = css`
  top: var(--spacing-4);
  right: var(--spacing-4);
  z-index: 20;
  background-color: rgba(255, 255, 255, 0.9);
  border-radius: var(--radius-xxl, 25px);
  padding: var(--spacing-2) var(--spacing-4);

  &:hover {
    background-color: var(--color-base-white, #ffffff);
  }
`;

export const scrollLayerOverrideStyles = css`
  padding: 0;
  background-color: rgba(0, 0, 0, 0.95);
`;

export const containerOverrideStyles = css`
  background-color: transparent;
  box-shadow: none;
  border-radius: 0;
  max-height: 100dvh;
`;

export const contentOverrideStyles = css`
  height: 100%;
  padding: 0;
`;
